import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportProductRequestPage } from './report-product-request.page';

const routes: Routes = [
  {
    path: '',
    component: ReportProductRequestPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportProductRequestPageRoutingModule {}
